<template>
 <div>

   <Modal :mask-closable="false" draggable @on-close="closeDialog" class="demo-drawer-prime"
          title="Print LR" v-model="dialog" width="450">
     <div slot="close" id="close-btn"><Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>
       <Row :gutter="10" style="padding:10px 0px 20px 0">
         <Col span="24">
           <div style="font-size: 14px">Number of Copy</div>
             <RadioGroup v-model="numOfCopy">
               <Radio label="Single Copy"/> <Radio label="Full Copy"/>
             </RadioGroup>
         </Col>
       </Row>
     <div slot="footer">
       <Button type="primary" size="large" @click="downloadPDF" :loading="loading">PRINT</Button>
       <Button class="cancel-btn" size="large" @click="closeDialog" id="cancel-btn">CANCEL</Button>
     </div>
   </Modal>

 </div>
</template>

<script>
import {Constants} from "../../Constants/Constant";

export default {
    name: "DownloadLR",
    props: ['dialog', 'lr'],                                              /* lr as object/array */
    data(){
      return{
        Constants: Constants,
        numOfCopy: 'Single Copy',
        mapCopy: {'Single Copy': 1, 'Full Copy': 3},
        loading: false
      }
    },
    methods:{
      downloadPDF(){
        if(Array.isArray(this.lr)){                 /* For Bulk Print */
          this.lr.forEach(curnt => window.open(`${Constants.api_url}performaLRPdf/${curnt.id}/${this.mapCopy[this.numOfCopy]}/${curnt.obj.status}`, '_blank'))
        }else {                                     /* On Row Print */
          window.open(`${Constants.api_url}performaLRPdf/${this.lr.id}/${this.mapCopy[this.numOfCopy]}/${this.lr.obj.status}`, '_blank')
        }
        // this.$emit('resetSelectedRows', []);
        this.closeDialog()
      },
      closeDialog(){
        this.numOfCopy = 'Single Copy';
        this.$emit('update:lr', null);
        this.$emit('update:dialog', false);
      }
    }
}
</script>

<style scoped>

</style>
